import { useTranslation } from "react-i18next";
import {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import clsx from "classnames";
import style from "./Input.module.scss";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import useAltEffect from "shared/hooks/useAltEffect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import Center from "layouts/wrapper/Center";
import { ToastContainer, toast } from "react-toastify";


const InputNumberMobile = forwardRef((props, ref) => {
  const input = useRef();
  const {
    min,
    max,
    placeHolder,
    disabled,
    required,
    allowedQuantity,
    hideLeftArrow,
    hideRightArrow,
    hideArrow,
    borderless,
    isAllowed = true,
  } = props;
  const { t } = useTranslation();
  const [name, setName] = useState(props.name || "");
  const [value, setValue] = useState(props.value ? props.value : 0);
  const [isValid, setValid] = useState(required ? false : true);
  const [helperText, setHelperText] = useState("");
  const [isEmpty, setEmpty] = useState(true);
  const [block, setBlock] = useState(false);

  useEffect(() => {
    const handleWheel = (event) => {
      event.stopPropagation();
      event.preventDefault();
    };

    const inputElements = document.querySelectorAll("input");
    inputElements.forEach((input) => {
      input.addEventListener("wheel", handleWheel);
    });

    return () => {
      inputElements.forEach((input) => {
        input.removeEventListener("wheel", handleWheel);
      });
    };
  }, []);

  const changeValue = (v) => {
    let changedValue = Math.max(min ? min : 0, Math.min(max ? max : 99999, v));
    if (allowedQuantity !== undefined && changedValue > allowedQuantity) {
      changedValue = allowedQuantity;
    }

    if (props.onChange) {
      props.onChange(changedValue);
    }
    setValue(changedValue);
  };

  const onChange = (e) => {
    if (!isAllowed) {
      toast.error(t("재고를 확인해주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      }); setValue(0);  // 또는 이전 값으로 되돌리기
      return;
    }

    let inputValue = Number(e.target.value);
    if (isEmpty) {
      setEmpty(false);
    }
    changeValue(inputValue);
  };

  const onPlusClick = (e) => {
    if (isAllowed) {
      e.stopPropagation();
      if (disabled) return;
      if (isEmpty) {
        setEmpty(false);
      }
      changeValue(value + 1);
    } else {
      toast.error(t("재고를 확인해주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const onMinusClick = (e) => {
    e.stopPropagation();
    if (disabled) return;

    if (isEmpty) {
      setEmpty(false);
    }
    changeValue(value - 1);
  };

  useImperativeHandle(ref, () => ({
    getName() {
      return name;
    },
    getValue() {
      return value;
    },
    setValue(value) {
      setValue(value);
    },
    isValid() {
      return isValid;
    },
    focus() {
      if (isValid) {
        setHelperText("");
      } else {
        setHelperText("수량을 입력해주세요");
      }
      input.current.scrollTo(0, input.current.offsetTop);
    },
  }));

  useAltEffect(() => {
    if (props.value) {
      setValue(props.value);
    }
  }, [props.value]);

  useAltEffect(() => {
    if (required) {
      if (value > 0) {
        setValid(true);
      } else {
        setValid(false);
      }
    }

    if (value <= min) {
      setBlock(true);
    } else {
      setBlock(false);
    }
  }, [value]);

  useEffect(() => {
    if (isValid) {
      setHelperText("");
    } else {

      return
      // if (!isEmpty) {
      //   setHelperText("수량을 입력해주세요");
      // }
    }
  }, [isValid, isEmpty]);

  return (
    <div className={style.numberInputWrapper}>
      <HorizontalFlex height={props.height} justifyContent={"flex-start"} width={"max-content"}>
        <FlexChild width={"initial"}>
          <span
            onClick={onMinusClick}
            className={clsx(
              style.newLeftArrow,
              { [style.active]: block }
            )}
          >
            <Center>
              <FontAwesomeIcon icon={faMinus} />
            </Center>
          </span>
        </FlexChild>
        <FlexChild width={"max-content"}>
          <div ref={input} className={style.mobileWrap}>
            <input
              type="number"
              name={name}
              className={clsx(
                style.input,
                {
                  [style.withPlaceHolder]: placeHolder ? true : false,
                  [style.hideLeftArrow]: hideArrow || hideLeftArrow,
                  [style.hideRightArrow]: hideArrow || hideRightArrow,
                }
              )}
              style={props.style}
              onChange={onChange}
              value={Number(value || 0).toString()}
              disabled={disabled ? true : null}
            />
          </div>
        </FlexChild>
        <FlexChild width={"initial"}>
          <span
            onClick={onPlusClick}
            className={style.newRightArrow}
          >
            <Center>
              <FontAwesomeIcon icon={faPlus} />
            </Center>
          </span>
        </FlexChild>
      </HorizontalFlex>
      {helperText && <div className={style.helperText}>{helperText}</div>}
    </div>
  );
});

export default InputNumberMobile;